"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _uiLogger = _interopRequireDefault(require("@ow/ui-logger"));
var _manager = require("../../constants/manager");
var _tagUtils = require("../../utils/tagUtils");
var _loadjs = _interopRequireDefault(require("loadjs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var log = (0, _uiLogger.default)();
function listener(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    type = _ref2[0],
    payload = _ref2[1];
  switch (type) {
    case _manager.EVENT:
      {
        var name = payload.name;
        if (name === _manager.events.PAGE_VIEW) {
          try {
            // Check and remove existing script
            (0, _tagUtils.removeExistingHeadTagById)('adroll_script');
            (0, _loadjs.default)(['https://s.adroll.com/j/roundtrip.js'], {
              before: function before(path, scriptEl) {
                /* called for each script node before being embedded */
                scriptEl.id = 'adroll_script';
                scriptEl.textContent = 'adroll_adv_id = "QCKQRKKSHZDVLNWT6SXN2D";\n' + 'adroll_pix_id = "FNGLYHQBDVESHIM2WVPOAM";';
                scriptEl.type = 'text/javascript';
                scriptEl.async = true;
              }
            });
          } catch (err) {
            log.error('Error in AdRollTags Subscriber for ViewPage: ' + err);
          }
        }
        break;
      }
  }
}
var _default = listener;
exports.default = _default;